export function TruckIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 20 19"
      className={className}
    >
      <path
        fill="#02C874"
        stroke="white"
        strokeLinejoin="round"
        d="M1 1h12v13H1zM13 5h3.43L19 8.38V14h-6V5Z"
      />
      <path
        fill="#02C874"
        stroke="white"
        strokeLinejoin="round"
        d="M13 9h6v5h-6V9Z"
      />
      <circle cx="4.2" cy="15.8" r="1.8" fill="#02C874" stroke="white" />
      <circle cx="15" cy="15.8" r="1.8" fill="#02C874" stroke="white" />
    </svg>
  );
}

export function ReturnsIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 20 24"
      className={className}
    >
      <circle cx="10.06" cy="10.92" r="9.56" fill="#02C874" stroke="white" />
      <path
        stroke="white"
        strokeLinecap="round"
        d="M14.78 7.78a5.75 5.75 0 1 1-4.15-2.43"
      />
      <path
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m9.05 3.5 2.03 1.86-1.86 2.03"
      />
    </svg>
  );
}
